import { render } from "./deptCard.vue?vue&type=template&id=a57c06be&scoped=true"
import script from "./deptCard.vue?vue&type=script&lang=js"
export * from "./deptCard.vue?vue&type=script&lang=js"

import "./deptCard.vue?vue&type=style&index=0&id=a57c06be&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a57c06be"]])

export default __exports__